"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _ommitProps = require("../../utils/ommit-props");

var _core = require("@emotion/core");

var ommitTypographyProps = (0, _ommitProps.ommitProps)(['as', 'color', 'fontFamily', 'fontSize', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'textAlign', 'textTransform', 'wordBreak']);
var StyledTypography = (0, _theme.styled)('span', {
  shouldForwardProp: ommitTypographyProps
})(function (_ref) {
  var color = _ref.color,
      fontFamily = _ref.fontFamily,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      textAlign = _ref.textAlign,
      textTransform = _ref.textTransform,
      theme = _ref.theme,
      wordBreak = _ref.wordBreak;
  return {
    color: color ? theme.palette[color] : undefined,
    fontFamily: fontFamily ? theme.font[fontFamily] : 'inherit',
    fontSize: fontSize ? theme.fontSizes[fontSize] || fontSize : undefined,
    fontWeight: fontWeight ? theme.weights[fontWeight] : undefined,
    letterSpacing: letterSpacing,
    lineHeight: lineHeight ? theme.lineHeights[lineHeight] || lineHeight : 'inherit',
    textAlign: textAlign,
    textTransform: textTransform,
    wordBreak: wordBreak
  };
});

function Typography(props) {
  var typographyComponent = _react.default.useRef(props.as ? StyledTypography.withComponent(props.as, {
    target: "e12lgu630"
  }) : StyledTypography);

  var Tag = typographyComponent.current;
  return (0, _core.jsx)(Tag, props);
}

var _default = Typography;
exports.default = _default;